"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.geomspace = exports.linspace = exports.arange = exports.ones = exports.zeros = exports.empty = void 0;
//@ts-check
var NDArray_1 = require("../NDArray");
var _a = NDArray_1.default.prototype.modules, basic = _a.basic, elementwise = _a.elementwise;
/**
 * Creates a new array with the specified shape and type, without initializing entries.
 */
function empty(shape, dtype) {
    if (dtype === void 0) { dtype = Float64Array; }
    return basic.new_from(shape, undefined, dtype);
}
exports.empty = empty;
;
/**
 * Creates a new array of zeros with the specified shape and dtype.
 */
function zeros(shape, dtype) {
    if (dtype === void 0) { dtype = Float64Array; }
    return basic.new_from(shape, function (_) { return 0; }, dtype);
}
exports.zeros = zeros;
;
function ones(shape, dtype) {
    if (dtype === void 0) { dtype = Float64Array; }
    return basic.new_from(shape, function (_) { return 1; }, dtype);
}
exports.ones = ones;
;
function arange(arg0, arg1) {
    if (arg1 === void 0) { arg1 = null; }
    var start, end;
    if (arg1 === null)
        start = 0, end = arg0;
    else
        start = arg0, end = arg1;
    return basic.new_from(end - start, function (_, i) { return start + i; }, Int32Array);
}
exports.arange = arange;
;
function linspace(start, stop, steps, endpoint) {
    if (steps === void 0) { steps = 50; }
    if (endpoint === void 0) { endpoint = true; }
    start = basic.as_number(start);
    stop = basic.as_number(stop);
    var n = (steps - (endpoint ? 1 : 0));
    var arr = arange(steps).divide(n).multiply(stop - start).add(start);
    return arr;
}
exports.linspace = linspace;
function geomspace(start, stop, steps, endpoint) {
    if (steps === void 0) { steps = 50; }
    if (endpoint === void 0) { endpoint = true; }
    start = Math.log(start);
    stop = Math.log(stop);
    return elementwise.funcs.exp(linspace(start, stop, steps, endpoint));
}
exports.geomspace = geomspace;
